export default "__VITE_ASSET__aZwXI$sK__"